import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { PackageContentForm } from './package-content-form.component'
import { PackageContentBlock } from './package-content-block.component'
import { PackageContentBlockInDetail } from './package-content-block-in-detail.component'

export default {
  PackageContentForm,
  usePackageContent: () => {
    const selector = formValueSelector('vanbooking-order')
    return useSelector(state =>
      selector(state, 'order_request_extra_attributes.package_content')
    )
  },
  PackageContentBlock,
  deleteValueForQuote: values => {
    return {
      ...values,
      order_request_extra_attributes: {
        ...values.order_request_extra_attributes,
        package_content: undefined,
      },
    }
  },
  PackageContentBlockInDetail,
}
